import store from "../store/store";
import { checkLineFriendship } from "../services/lineApi.service";
import config from "@/config";
import { jwtDecode } from "jwt-decode";
import commonUtilities from "./common.utils";

function checkIsTokenValid(token) {
    try {
        if (token) {
            const tokenInfo = jwtDecode(token);
            const tokenExpiration = tokenInfo.exp;
            // 將 timestamp 轉換成時間格式並比對當前時間
            const currentTime = new Date().getTime() / 1000;
            // 將 token 過期時間轉換成時間格式
            const date = new Date(tokenExpiration * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
            console.log("okshop token 過期時間", formattedDate);
            if (currentTime > tokenExpiration) {
                return false;
            } else {
                return true;
            }
        } else {
            console.log('no token passing in')
            return false
        }
    } catch (e) {
        console.log("store data not found", e)
        return false
    }
}

function logout() {
    // 取得使用者識別碼（在清除前）
    const userIdentifier = store.getters['userData/storeMemberUuid']

    // 清除 store data && member info
    store.commit('userData/setStoreData', {})
    store.commit('userData/setMemberInfo', {})

    // 清除店家列表快取（換會員/登出時避免殘留）
    store.commit('storeList/resetStores')

    // 清除當前用戶的公告顯示記錄（確保重新登入時能看到公告）
    if (userIdentifier) {
        sessionStorage.removeItem(`store_notice_shown_${userIdentifier}`)
    }
}


async function okShopLogin() {
    const accessToken = store.getters['line/accessToken'];
    // 檢查 line好友 如果不是好友的話不進行 gen2 pos 登入
    console.log("start checking line friendship");
    if (!(await checkLineFriendship(accessToken))) {
        // // 將 config.lineId 透過 UTF-8 Encode
        const encodedLineId = encodeURIComponent(config.lineId);
        window.location.href = `${config.lineAddFriendApiUrl}/ti/p/${encodedLineId}`;
    }

    // 計時兩分鐘 如果兩分鐘累都沒有加入 line 好友 在 while loop 中丟出錯誤
    const startTime = new Date().getTime();
    const endTime = startTime + 120000;
    while (!(await checkLineFriendship(accessToken))) {
        await commonUtilities.delay(1500);
        console.log("等待使用者加入 line 官方好友");
        if (new Date().getTime() > endTime) {
            throw new Error("請先加入 Line 官方好友");
        }
    }
    console.log(store.state.basic.currentStore)

    const sendData = {
        type: "1",
        store_code: store.state.basic.currentStore,
        line_id_token: store.getters['line/idToken'],
        access_token: accessToken,
    };

    // 如果 gen2 pos 系統登入失敗 顯示彈窗並留在商店資訊頁
    console.log("start logging in gen2 pos system", sendData);
    await store.dispatch("userData/login", sendData)
}

// 確認已加入 OKShop 官方好友；非好友則跳轉加好友頁並回傳 false
async function ensureOkShopFriendship() {
    const accessToken = store.getters['line/accessToken'];
    if (!(await checkLineFriendship(accessToken))) {
        const encodedLineId = encodeURIComponent(config.lineId);
        window.location.href = `${config.lineAddFriendApiUrl}/ti/p/${encodedLineId}`;
        return false;
    }
    return true;
}

export default {
    checkIsTokenValid,
    logout,
    okShopLogin,
    ensureOkShopFriendship
}